import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DidUser } from "../../interfaces/Did.type";

const initialState: DidUser[] = [];

export const didsSlice = createSlice({
    name: "didUsers",
    initialState,
    reducers: {
        setSmsDidsUsers: (_, action: PayloadAction<DidUser[]>) => {
            return action.payload;
        },

    },
});

export const { setSmsDidsUsers } = didsSlice.actions;
export default didsSlice.reducer;